import { useBasketStore, useGlobalStore, useOrderStore } from "../store/hooks/useStore"
import { CHECKOUT_ERROR_MESSAGES } from "../utils/constants"
import useNavigation from "./use-navigation"

export const useBasketReview = () => {
    const navigate = useNavigation()
    const basketStore = useBasketStore()
    const {setShowCheckoutSummary} = useGlobalStore()
    
    const reviewBasket = async () => {
        const beforeValue = basketStore.basketHash

        await basketStore.getOrCreateBasket()

        const isValid = beforeValue === basketStore.basketHash

        if (!isValid) {
            setShowCheckoutSummary(true)
            navigate('/checkout/summary', 'replace', {
                errorMessage: CHECKOUT_ERROR_MESSAGES.ERROR_BASKET_TOTAL
            })
        }

        return isValid
    }

    return {
        reviewBasket
    }
}